// Shared constants for chart types
export const CHART_TYPE_LINE = 'line';
export const CHART_TYPE_HEATMAP = 'heatmap';

export type ChartType = typeof CHART_TYPE_LINE | typeof CHART_TYPE_HEATMAP;
